import { JobStates } from "../ViewerLayout/ViewerLayoutTypes";
import {
  PropertyTranslator,
  IGenericRequestParametersTranslator,
  IPaginationParametersTranslator,
  INamedEntityParametersTranslator,
  INamedEntityLabels,
  IPermissionedEntityLabels,
} from "./GenericTranslator";
import {
  IModelWithIntId,
  IPermissionedEntity,
  IRelationModel,
  IPaginationParameters,
  IGenericRequestParameters,
  EntityConstants,
  GenericEntityOrderBy,
  TypedEntitySuggestionsModel,
  INamedEntity,
  INamedEntityParameters,
  NamedEntityOrderBy,
} from "./GenericTypes";

export const fileExportJobsConstants: EntityConstants<FileExportJob, FileExportJobFilters> = {
  resource: "file_export_jobs",
  frontendIndexRoute: "file_export_jobs",
  entitySingular: "exported file",
  entityPlural: "exported files",
  icon: "file-spreadsheet",
};

export interface FileExportJob extends IModelWithIntId, IPermissionedEntity, INamedEntity {
  progress?: number;
  status?: JobStates;
  numberOfItems?: number;
  createdAt?: string;
  expiresAt?: string;
  error?: string;
  isSingleFile?: boolean;
  mediaType?: string;
  isDownloaded?: boolean;
}

export const FileExportJobFieldLabels: PropertyTranslator<FileExportJob> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  id: "Job ID",
  progress: "Progress",
  status: "Status",
  numberOfItems: "Total number of exported items",
  createdAt: "File created at",
  expiresAt: "Expires at",
  error: "Error",
  isSingleFile: "Is single file",
  mediaType: "Media Type",
  isDownloaded: "Is downloaded",
} as const;

export interface FileExportJobSuggestions extends TypedEntitySuggestionsModel<FileExportJob["id"]> {}

export interface FileExportJobRelations extends IRelationModel {}

export const FileExportJobSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  "CREATED_AT",
  "EXPIRES_AT",
] as const;
export type FileExportJobSortingOptions = (typeof FileExportJobSortingOptionsConsts)[number];

export interface FileExportJobFilters
  extends IPaginationParameters,
    IGenericRequestParameters<FileExportJob, FileExportJobSortingOptions>,
    INamedEntityParameters {
  isDownloaded?: boolean;
  isFinished?: boolean;
}

export const FileExportJobFiltersTranslator: PropertyTranslator<FileExportJobFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  ...INamedEntityParametersTranslator,
  isDownloaded: "Is downloaded",
  isFinished: "Is finished",
} as const;

export const FileExportJobSearchTermOptions = {
  searchTermIncludeNames: FileExportJobFiltersTranslator["searchTermIncludeNames"],
  searchTermIncludeIds: FileExportJobFiltersTranslator["searchTermIncludeIds"],
  searchTermIncludeUuids: FileExportJobFiltersTranslator["searchTermIncludeUuids"],
  searchTermIncludeCustomFieldValues: FileExportJobFiltersTranslator["searchTermIncludeCustomFieldValues"],
} as const;
